import type { SlotMove } from '../generated/sim/runtime/battle-harness';

export const NO_OP_INDEX = 126;
export const SWITCH_MOVE_INDEX = 125;
// The rest / no-op SlotMove an idle doubles slot submits.
export const NO_OP_SLOT: SlotMove = { moveIndex: NO_OP_INDEX, extraData: 0 };
export const ZERO_BYTES_32 = '0x0000000000000000000000000000000000000000000000000000000000000000';
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
export const MAX_MOVES = 4;
export const MAX_STAMINA = 5;
export const CHAT_DELAY_MS = 600;
export const QUICK_PING_PRESETS = ['Hurry up!', 'That hurt!', 'Nice one!'] as const;
export const TEAM_SIZE = 4;
// Hit lands once this fraction of the attack animation has played. Tunable [0,1].
export const ATTACK_DAMAGE_TIMING_FRACTION = 0.8;
// HP bar fill transition, consumed by app-hp-bar / app-mobile-hud-plate (and the matching
// setTimeout hold on each plate's flash highlight while the bar drains).
export const HP_BAR_DRAIN_MS = 300;
// Battle-log notification lifecycle: hold fully visible, then fade, then remove
// once faded. BATTLE_LOG_FADE_MS drives the .battle-log-entry opacity transition.
export const BATTLE_LOG_DWELL_MS = 3500;
export const BATTLE_LOG_FADE_MS = 500;
export const MAX_BATTLE_MSG_LENGTH_MOBILE_SMALL = 30;
export const MAX_BATTLE_MSG_LENGTH_MOBILE = 38;
export const MAX_BATTLE_MSG_LENGTH_DESKTOP = 100;
export const MON_STAT_SENTINEL_VALUE = 2147483646;
export const RECC_DEPOSIT_AMOUNT = 0.00005;

export const GACHA_OUTCOME_WIN  = 1;
